export default "__VITE_ASSET__D0bY9m3K__"